var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-embed',{staticClass:"youtube",attrs:{"src":'https://www.youtube.com/embed/' + _vm.video + '?rel=0',"allowfullscreen":"","aspect":"16by9","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"}})
}
var staticRenderFns = []

export { render, staticRenderFns }